import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Target, Calendar, DollarSign } from 'lucide-react';
import PageHeader from '../components/PageHeader';

export const CampaignDetails: React.FC = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-full">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 mb-3"
          >
            <ArrowLeft className="h-4 w-4 mr-1" />
            Back
          </button>
          <PageHeader
            icon={<Target className="h-8 w-8" />}
            title="Campaign Details"
            subtitle={`Campaign ID: ${campaignId}`}
          />
        </div>

        {/* Placeholder Content */}
        <div className="bg-white rounded-lg shadow-sm p-6 text-center">
          <Target className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Campaign Details</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-md mx-auto">
            <button 
              onClick={() => navigate(`/campaign/${campaignId}/budget`)}
              className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              <DollarSign className="h-4 w-4 mr-2" />
              Budget
            </button>
            <button 
              onClick={() => navigate(`/campaign/${campaignId}/insights`)}
              className="flex items-center justify-center px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
            >
              <Target className="h-4 w-4 mr-2" />
              Insights
            </button>
            <button className="flex items-center justify-center px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors">
              <Calendar className="h-4 w-4 mr-2" />
              Schedule
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
